import OpenCashier from "./OpenCashier";
import GameLoadStart from "./GameLoadStart";
import GameLoadEnd from "./GameLoadEnd";
import BalanceChange from "./BalanceChange";
import GameSpinStart from "./GameSpinStart";
import GameSpinEnd from "./GameSpinEnd";
import CloseGame from "./CloseGame";
import OutOfMoney from "./OutOfMoney";
import SoundOff from "./SoundOff";
import SoundOn from "./SoundOn";
import RequestRefresh from "./RequestRefresh";
import KeepAlive from "./KeepAlive";
import RequestLogin from "./RequestLogin";
import RequestRegister from "./RequestRegister";
import Error from "./Error";
import Resize from "./Resize";
import GameHistory from "./GameHistory";
import RealityCheckCloseGame from "./RealityCheckCloseGame";
import Logout from "./Logout";
import LogoutSuccess from "./LogoutSuccess";
import OpenTable from "./OpenTable";
import GameRoundEnd from "./GameRoundEnd";
import TicketResolved from "./TicketResolved";
import ListenersReady from "./ListenersReady";
import RequestFullScreen from "./RequestFullScreen";
import ExitFullScreen from "./ExitFullScreen";
import LobbyLoadEnd from "./LobbyLoadEnd";
import UrlChanged from "./UrlChanged";
import ResultsShown from "./ResultsShown";
import WonAmountChange from "./WonAmountChange";
import GamePaused from "./GamePaused";
import GameResumed from "./GameResumed";
import GameAutoplayEnd from "./GameAutoplayEnd";
import GameAutoplayStart from "./GameAutoplayStart";
import BetAmountChange from "./BetAmountChange";
import GameLoadProgress from "./GameLoadProgress";
import OpenHelp from "./OpenHelp";
import CloseHelp from "./CloseHelp";
import ClosePaytable from "./ClosePaytable";
import GameLaunchUrl from "./GameLaunchUrl";
import GameJackpotEnd from "./GameJackpotEnd";
import GameJackpotStart from "./GameJackpotStart";
import GameChange from "./GameChange";

export default class WebEmitters {
    constructor(gb) {
        Object.assign(this, { gb });

        this.gameLoadEndEventTriggered = false;
    }

    openCashier() {
        new OpenCashier(this.gb).exec();
    }

    gameLoadStart() {
        new GameLoadStart(this.gb).exec();
    }

    gameLoadEnd(msg) {
        if (this.gameLoadEndEventTriggered === true) return;

        new GameLoadEnd(this.gb).exec(msg);
        this.gameLoadEndEventTriggered = true;
    }

    balanceChange(balance) {
        new BalanceChange(this.gb).exec(balance);
    }

    gameSpinStart(data) {
        new GameSpinStart(this.gb).exec(data);
    }

    gameSpinEnd(data) {
        new GameSpinEnd(this.gb).exec(data);
    }

    gameRoundEnd() {
        new GameRoundEnd(this.gb).exec();
    }

    closeGame(data) {
        new CloseGame(this.gb).exec(data);
    }

    closeHelp() {
        new CloseHelp(this.gb).exec();
    }

    closePaytable() {
        new ClosePaytable(this.gb).exec();
    }

    outOfMoney() {
        new OutOfMoney(this.gb).exec();
    }

    soundOff() {
        new SoundOff(this.gb).exec();
    }

    soundOn() {
        new SoundOn(this.gb).exec();
    }

    requestRefresh() {
        new RequestRefresh(this.gb).exec();
    }

    keepAlive() {
        new KeepAlive(this.gb).exec();
    }

    requestLogin() {
        new RequestLogin(this.gb).exec();
    }

    requestRegister() {
        new RequestRegister(this.gb).exec();
    }

    requestFullScreen() {
        new RequestFullScreen(this.gb).exec();
    }

    exitFullScreen() {
        new ExitFullScreen(this.gb).exec();
    }

    error(msg) {
        new Error(this.gb).exec(msg);
    }

    resize(obj) {
        new Resize(this.gb).exec(obj);
    }

    logout() {
        new Logout(this.gb).exec();
    }

    logoutSuccess() {
        new LogoutSuccess(this.gb).exec();
    }

    gameHistory(alreadyHandled) {
        new GameHistory(this.gb).exec(alreadyHandled);
    }

    ticketResolved() {
        new TicketResolved(this.gb).exec();
    }

    listenersReady() {
        new ListenersReady(this.gb).exec();
    }

    realityCheckCloseGame() {
        new RealityCheckCloseGame(this.gb).exec();
    }

    openTable(data) {
        new OpenTable(data).exec();
    }

    lobbyLoadEnd() {
        new LobbyLoadEnd(this.gb).exec();
    }


    urlChanged(data) {
        new UrlChanged(this.gb).exec(data);
    }

    passthru(msg) {
        if (typeof msg !== "string") {
            try {
                msg.gameBridgePassthru = true;
            } catch (e) {}
        }

        logger.info("... passing to WEB", msg);
        window.parent.postMessage(msg, "*");
    }

    resultsShown(msg) {
        new ResultsShown(this.gb).exec(msg);
    }

    betAmountChange(msg) {
        new BetAmountChange(this.gb).exec(msg);
    }

    wonAmountChange(msg) {
        new WonAmountChange(this.gb).exec(msg);
    }

    gamePaused(msg) {
        new GamePaused(this.gb).exec(msg);
    }

    gameResumed(msg) {
        new GameResumed(this.gb).exec(msg);
    }

    gameAutoplayStart(msg) {
        new GameAutoplayStart(this.gb).exec(msg);
    }

    gameAutoplayEnd(msg) {
        new GameAutoplayEnd(this.gb).exec(msg);
    }

    openHelp(msg) {
        new OpenHelp(this.gb).exec(msg);
    }

    gameLoadProgress(msg) {
        new GameLoadProgress(this.gb).exec(msg);
    }

    gameLaunchUrl(msg) {
        new GameLaunchUrl(this.gb).exec(msg);
    }

    gameJackpotStart(msg){
        new GameJackpotStart(this.gb).exec(msg)
    }

    gameJackpotEnd(msg){
        new GameJackpotEnd(this.gb).exec(msg)
    }

    gameChange(msg){
        new GameChange(this.gb).exec(msg)
    }

    customMsg(msg) {
        logger.info("Custom msg to WEB", msg);
        window.parent.postMessage(msg, "*");
    }
}
